import { washListCert } from '@/utils/wash.js'
const washData = (node) => {
  try {
    switch (node._type) {
      case 'list_cert_three':
        washListCert(node, 'divContainer', 'componentName')
        washListCert(node, 'cert-list-img' )
        break
    }
  } catch (err) {
    console.log('err--', err)
  }
}
export { washData }
